import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { getPosttypeChatlist } from "../../../redux/chatandnotification/action";
import ChatInputBox from "./ChatInputBox";
import ChatScrollBottom from "../ChatwithMultipleUser/ChatScrollBottom";
import { useRouteBaseStateContext } from "../../../Context/RouteBaseStateContext";
import { useChatPagination } from "../../../Context/ChatPaginationContext";

export default function GroupMessageDetails({ teamoverview }) {
  const { urlstate } = useRouteBaseStateContext();
  const { setIndex, index, size } = useChatPagination();

  const path = "Assets/scss/chat.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const dispatch = useDispatch();

  const [proposalmilestones, setproposalmilestones] = useState("");
  const chatdatails = useSelector(
    ({ chatandnotification: { getposttypechatlist } }) => getposttypechatlist,
  );
  const notificationCount = useSelector(
    ({ chatandnotification: { getnotificationcount } }) => getnotificationcount
  );

  useEffect(() => {
    if (teamoverview?.company_id) {
      dispatch(getPosttypeChatlist(3, "", teamoverview?.company_id, index, size));
    }
  }, [teamoverview, notificationCount.notification, index]);

  return (
    <>
      <div className="chat-message">
        <div className="chatbox-second">
          <ChatScrollBottom 
            chatdatails={chatdatails} 
            selectUser={teamoverview}
            isGroupChat={true}
          />
        </div>
        <ChatInputBox teamoverview={teamoverview} />
      </div>
    </>
  );
}